import {Component, Input, OnInit} from '@angular/core';
import {Lesson} from '../models/lesson.model';
import {Course} from '../models/course.model';
import {UserLessonStatus} from '../models/user-lesson-status';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {updateLessonWatchStatus} from '../store/user-lesson-status.actions';
import {MatCheckboxChange, MatCheckboxModule} from '@angular/material/checkbox';
import {isAnonymousUser, isSubscriptionActive, User} from '../models/user.model';
import {selectUser, selectUserCoursesIds} from '../store/selectors';
import {ResponsiveLayoutService} from '../services/responsive-layout.service';
import {map} from 'rxjs/operators';
import {Breakpoints} from '@angular/cdk/layout';
import {MessagesService} from '../shared/services/messages.service';
import {DurationPipe} from '../shared/pipes/duration.pipe';
import {RouterLink} from '@angular/router';
import {NgClass, NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'lessons-list',
    templateUrl: './lessons-list.component.html',
    styleUrls: ['./lessons-list.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, RouterLink, NgClass, MatCheckboxModule, DurationPipe]
})
export class LessonsListComponent implements OnInit {

  @Input()
  course: Course;

  @Input()
  sectionSeqNo: number;

  @Input()
  lessons: {sectionLessons: Lesson[],  sectionStartIndex: number} = {sectionLessons: [], sectionStartIndex: 0};

  @Input()
  lessonsWatched: string[] = [];

  @Input()
  highlightedLesson: Lesson;

  @Input()
  playlistMode: boolean;

  user: User;

  showExtraIcons:boolean;

  showLessonsListIcon: boolean;

  userCoursesIds: string[] = [];

  constructor(
    private store: Store<AppState>,
    private messages: MessagesService,
    private responsive: ResponsiveLayoutService) {
  }

  ngOnInit() {

    this.store.pipe(
      select(selectUser)
    )
    .subscribe(user => this.user = user);

    this.responsive.matchesAny(Breakpoints.HandsetPortrait, Breakpoints.TabletLandscape)
      .pipe(map(val => !val))
      .subscribe(matches => this.showExtraIcons = matches);

    this.responsive.matchesAny(Breakpoints.HandsetPortrait, Breakpoints.TabletLandscape)
      .pipe(map(val => !val))
      .subscribe(matches => this.showLessonsListIcon = matches);

    this.store.pipe(select(selectUserCoursesIds))
      .subscribe(userCoursesIds => this.userCoursesIds = userCoursesIds);

  }


  onLessonViewedClicked(event: MatCheckboxChange, lesson: Lesson) {

    if (isAnonymousUser(this.user)) {
      this.messages.i18nInfo("allLessons.messages.loginFirstToMarkLessonsAsViewed");
      event.source.checked = ! event.checked;
      return;
    }

    if (lesson?.type == 'quiz' && event.checked) {
      this.messages.i18nWarn("allLessons.messages.mustCompleteQuiz");
      event.source.checked = ! event.checked;
      return;
    }

    if (lesson?.type == 'assignment' && event.checked) {
      this.messages.i18nWarn("allLessons.messages.mustCompleteAssignment");
      event.source.checked = ! event.checked;
      return;
    }

    if (lesson?.type == 'assignment' && !event.checked) {
      this.messages.i18nWarn("allLessons.messages.onlyAdminCanUpdateAssigment");
      event.source.checked = ! event.checked;
      return;
    }

    if (!this.hasUserAccessToCourse() && event.checked) {
      this.messages.i18nWarn("course.messages.onlyRegisteredUsersCanMarkLessonsAsViewed");
      event.source.checked = ! event.checked;
      return;
    }

    const userLessonStatus: UserLessonStatus = {
      id: lesson.id,
      courseId: this.course.id,
      watched: event.checked
    };

    this.store.dispatch(updateLessonWatchStatus({userLessonStatus}));

  }

  hasUserAccessToCourse() {
    return this.userCoursesIds?.includes(this.course.id) || isSubscriptionActive(this.user) || this.course?.free;
  }

  onCheckBoxToggled(event) {
    event.stopPropagation();
  }

  isLessonWatched(lesson: Lesson) {
    return this.lessonsWatched.includes(lesson.id);
  }


  lessonClasses(lesson: Lesson) {
    return lesson && this.highlightedLesson && (lesson.id == this.highlightedLesson.id) ? 'active-lesson' : undefined;
  }

  isAnonymous() {
    return isAnonymousUser(this.user);
  }

}
